import { memo } from "react";

import type { RequestFilterType } from "../../../types/filters";

import { readyForReviewTableConfig } from "../../../config/tables/superadmin/readyForReviewTableConfig";
import { UnifiedSuperAdminTab } from "./UnifiedSuperAdminTab";

interface ReadyForReviewTabProps {
  lazyLoadingConfig?: {
    currentTab: string;
    enabled: boolean;
  };
  searchValue?: string;
  selectedFilter?: RequestFilterType;
}

function ReadyForReviewTabComponent(props: ReadyForReviewTabProps) {
  return (
    <UnifiedSuperAdminTab
      {...props}
      tableConfig={readyForReviewTableConfig}
      tabType="ready-for-review"
    />
  );
}

export const ReadyForReviewTab = memo(ReadyForReviewTabComponent);
